<script setup lang="ts">
import { h, ref } from 'vue';
import { useSessionStorage } from '@vueuse/core'
import {useTheme} from "~/composables/common";
import FullSearch from "~/components/FullSearch.vue";
import BaseDialog from "~/components/base/BaseDialog.vue";

const activeName = ref('home')

const borderWidth = ref('0px')

const tabConfig = [
    {
      name: '首页',
      path: 'home'
    },
    {
      name: '文章',
      path: 'articles'
    },
    {
      name: '后台管理',
      path: 'cms'
    },
    {
      name: '关于',
      path: 'about'
    }
]
const route = useRoute()

onMounted(() => {



  watch(() => route.path, (n, o) => {
    activeName.value = tabConfig.find(item => {
      return route.path.indexOf(`/${item.path}/`) === 0 || route.path === `/${item.path}`
    })?.path || 'home'
    nextTick(() => {
      const styleObj = getComputedStyle(document.querySelector('.active') as SVGTSpanElement)
      borderWidth.value = parseInt(styleObj.width) - parseInt(styleObj.paddingLeft) - parseInt(styleObj.paddingRight) + 'px'
    })
  }, { deep: true, immediate: true })
})

const { themeColor } = useTheme()

function switchTheme() {
  themeColor.value = themeColor.value === 'dark'? 'light': 'dark'
}

const router = useRouter()
function openPage(name: string) {
  activeName.value = name;
  borderWidth.value = '0px'
  router.push('/' + name)
}

const pageSearch = ref(false)
function openSearch() {
  pageSearch.value = true
}

</script>

<template>
  <div class="header-comp w-full bg-[var(--primary-color)] bb-1-solid bc-[var(--border-color)]">
    <div class="header w-1200px pt-vh-20 pb-vh-20 flex justify-between m-auto">
      <div class="flex gap-col-2">
        <div class="logo-icon flex justify-between items-center">
          <SketchOutlined />
        </div>
        <span class="web-title">我的博客</span>
      </div>
      <div class="flex-1 navbar flex justify-between">
        <ul class="flex flex-1 items-center]">

          <li v-for="item in tabConfig" :key="item.path">
            <a-button @click="openPage(item.path)" type="link" :style="{ color: 'var(--text-color)' }" size="large" :class="{ active: activeName === item.path }"
              name="home"><span>{{ item.name }}</span></a-button></li>
        </ul>
        <div class="flex items-center gap-col-2">
          <i>
            <a-button type="text" @click="openSearch">
              <SearchOutlined :style="{ color: 'var(--text-color)', 'font-size': '20px' }" />
            </a-button>
          </i>
          <a-avatar class="bg-img-[var(--icon-bg)]">
            <template #icon>
              <UserOutlined />
            </template>
          </a-avatar>
          <a-button type="link" @click="switchTheme">
            <BulbOutlined :style="{ color: 'var(--text-color)', 'font-size': '18px' }" />
          </a-button>
        </div>
      </div>
    </div>

    <BaseDialog v-model="pageSearch" destroyOnClose title="全文搜索">
      <FullSearch></FullSearch>
    </BaseDialog>
  </div>
</template>

<style scoped lang="scss">
.header-comp {

  .logo-icon {
    width: 40px;
    height: 40px;
    background: var(--icon-bg);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: white;
    margin-right: 10px;
  }

  .web-title {
    justify-self: self-start;
    font-size: 24px;
    color: var(--title-color);
    line-height: 40px;
  }

  .navbar {
    max-width: 70%;
  }

  .ant-btn-link:not(:disabled):hover {
    color: var(--title-color) !important;
  }

  .ant-btn-link:not(:disabled).active {
    color: var(--bold-color) !important;
    position: relative;
  }

  .ant-btn-link:not(:disabled).active::before {
    content: "";
    height: 2px;
    width: v-bind(borderWidth);
    background: var(--icon-bg);
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.5s;
  }

}
</style>